import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { RootState } from "../../../store/types";
import { Wrapper } from "../../../components";
import { MetaTags } from "../../../head";
import StepLayout from "../../Wizard/components/WizardStepLayout";
import LayoutCarousel from "./LayoutCarouselContainer";
import { State as Step1State, selectors as step1Selectors } from "../../Step1";
import { ATT_MATRIX_VALS } from "../../Wizard/constants";

export interface LayoutChoiceProps extends Step1State {}

class LayoutChoiceContainer extends React.Component<LayoutChoiceProps> {
  public render() {
    if (!this.props.chosenProduct) {
      // Go to step 1 if no product chosen
      return <Redirect to="/wizard/step-1" />;
    } else if (
      this.props.chosenProduct.attribute.layout === ATT_MATRIX_VALS.NA
    ) {
      // Skip this step if not applicable
      return <Redirect to="/wizard/step-3" />;
    }

    return (
      <Wrapper>
        <MetaTags title="Danh sách màu sắc" />
        <StepLayout
          title="Bố cục thiết kế"
          banner={
            <Wrapper>
              Bạn thích <span>{this.props.chosenProduct.name}</span> của mình có
              kiểu như thế nào?
            </Wrapper>
          }
          footnote="Nếu chưa chọn được mẫu ưng ý, bạn có thể bỏ qua, chúng tôi sẽ tư vấn trực tiếp"
        >
          <LayoutCarousel />
        </StepLayout>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state: RootState): Partial<LayoutChoiceProps> => ({
  chosenProduct: step1Selectors.chosenProduct(state),
});

export default connect(mapStateToProps)(LayoutChoiceContainer);



// WEBPACK FOOTER //
// ./src/routes/WizardLayoutChoice/components/LayoutChoiceContainer.tsx